// extracted by mini-css-extract-plugin
export default {"search-bar":"searchbar_search-bar__cf0L+"};